import { render, staticRenderFns } from "./ecoConventionIcon.vue?vue&type=template&id=7cfdefe6"
import script from "./ecoConventionIcon.vue?vue&type=script&lang=js"
export * from "./ecoConventionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports